import React, { ReactNode } from "react";

export interface SectionDividerProps {
	className?: string;
	children?: ReactNode;
}

const SectionDivider: React.FC<SectionDividerProps> = ({ className, children }) => {
	return <h3 className={`section-divider${className ? ` ${className}` : ""}`}>{children}</h3>;
};

export default SectionDivider;
